"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalSheetResolution = exports.ApprovalSheetStatus = exports.ApprovalSheetGroupType = void 0;
var ApprovalSheetGroupType;
(function (ApprovalSheetGroupType) {
    ApprovalSheetGroupType["REVIEWER"] = "REVIEWER";
    ApprovalSheetGroupType["REVIEW_SIGNER"] = "REVIEW_SIGNER";
    ApprovalSheetGroupType["APPROVER"] = "APPROVER";
    ApprovalSheetGroupType["APPROVE_SIGNER"] = "APPROVE_SIGNER";
    ApprovalSheetGroupType["SIGNER"] = "SIGNER";
})(ApprovalSheetGroupType = exports.ApprovalSheetGroupType || (exports.ApprovalSheetGroupType = {}));
var ApprovalSheetStatus;
(function (ApprovalSheetStatus) {
    ApprovalSheetStatus["CREATED_FLOW"] = "CREATED_FLOW";
    ApprovalSheetStatus["ACTIVE_FLOW"] = "ACTIVE_FLOW";
    ApprovalSheetStatus["CHECKING_COLLISION_FLOW"] = "CHECKING_COLLISION_FLOW";
    ApprovalSheetStatus["VERIFICATION_FLOW"] = "VERIFICATION_FLOW";
    ApprovalSheetStatus["STOPPED_FLOW"] = "STOPPED_FLOW";
    ApprovalSheetStatus["COMPLETED_FLOW"] = "COMPLETED_FLOW";
    ApprovalSheetStatus["REJECTED_FLOW"] = "REJECTED_FLOW";
})(ApprovalSheetStatus = exports.ApprovalSheetStatus || (exports.ApprovalSheetStatus = {}));
var ApprovalSheetResolution;
(function (ApprovalSheetResolution) {
    ApprovalSheetResolution["APPROVE"] = "APPROVE";
    ApprovalSheetResolution["REJECT"] = "REJECT";
})(ApprovalSheetResolution = exports.ApprovalSheetResolution || (exports.ApprovalSheetResolution = {}));
